<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
				<div class="container">
					<a class="navbar-brand" href="/#/">
						<img src="../../assets/img/logo.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-light btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section class="py-5 bg-grey200">
			<div class="container">
				<div class="row d-flex justify-content-center">
					<div class="col-md-6">
						<ul class="list-group checkout-list-group">
							<li class="list-group-item">
								<h4 class="text-lg-center text-sm-left">Almost Done!</h4>
								<p class="text-lg-center text-sm-left">
									Review your plan and checkout To start watching
								</p>
							</li>
							<li class="list-group-item">
								<div
									class="row d-flex align-items-center justify-content-between"
								>
									<div class="col-auto label-text">Payment Method</div>
									<div class="col-auto">
										<span
											v-if="$route.params.paymentmethod == 'paypal'"
											class="img"
											><img src="../../assets/img/paypal.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'visa'"
											class="img"
											><img src="../../assets/img/visa.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'mastercard'"
											class="img"
											><img src="../../assets/img/mastercard.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'glo'"
											class="img"
											><img src="../../assets/img/Glo_button.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'ussd'"
											class="img"
											><img src="../../assets/img/ussd.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'tigo'"
											class="img"
											><img src="../../assets/img/tigo.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'mpesa'"
											class="img"
											><img src="../../assets/img/mpesa.png"
										/></span>
										<span
											v-if="$route.params.paymentmethod == 'mtn'"
											class="img"
											><img src="../../assets/img/mtn.png"
										/></span>
									</div>
									<div class="col-auto">
										<a :href="getPaymentHref()" class="btn btn-outline-primary"
											>Edit</a
										>
									</div>
								</div>
							</li>
							<li class="list-group-item">
								<div
									class="row d-flex align-items-center justify-content-between"
								>
									<div class="col text-lg-center text-sm-left relative">
										<p>Payment plan</p>
										<h1 class="price">
											<small>{{ planCurrency }}</small>
											{{ planPrice }}
										</h1>
										<p class="text-green font-semibold">
											{{ planSub }}
										</p>
										<a
											href="/#/packages"
											class="btn btn-outline-primary edit-btn"
											>Change</a
										>
									</div>
								</div>
							</li>

							<li class="list-group-item">
								<ul class="list">
									<li
										v-for="(planDetails, index) in getPlanDetails()"
										:key="index"
										:class="{ 'gray-text': isNotAvailabele(planDetails) }"
										v-if="showPlanDeatils(planDetails)"
									>
										{{ planDetails }}
									</li>
									
								</ul>
							</li>

							<li class="list-group-item ">
								<p>Enter 20DISCOUNT as your coupon code to enjoy 20% off your first month subscription.</p>
								<p v-if="this.$store.getters.getGlobalConfigs.stripe_coupon_code_text">{{this.$store.getters.getGlobalConfigs.stripe_coupon_code_text}}</p>
								<div class="row d-flex align-items-center justify-content-left">
									<div class="col-auto label-text">Enter Coupon</div>
									<div class="col-auto mr-3">
										<input
											type="text"
											v-model="coupon"
											class="form-control coupon-input"
										/>
									</div>
								</div>
								<p v-if="showCouponError" class="pt-3 coupon-error-text">{{ couponErrorMsg }}</p>
							</li>
							<li class="list-group-item">
								<p>
									By checking the checkbox below, you agree to our Terms of Use,
									Privacy Statement, and that you are over 18. You may cancel at
									any time. Ibakatv will automatically continue your membership
									and charge the membership fee (currently ₦ {{ planPrice }}) to
									your payment method on a monthly basis until you cancel.
								</p>
								<div class="custom-control custom-checkbox mt-3">
									<input
										type="checkbox"
										v-model="checked"
										class="custom-control-input"
										id="customCheck1"
									/>
									<label class="custom-control-label label-text" for="customCheck1"
										>I Agree</label
									>
								</div>

								<!-- <div class="text-justify py-3">
									<div id="google_captcha"></div>
								</div> -->
								<div class="text-lg-center text-sm-left">
									
									<button
										@click="processStripePayment"
										class="btn btn-outline-light"
										:disabled="!checked"
									>
										START MEMBERSHIP
									</button>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<p class="text-lg-center text-sm-left pt-4 label-text">Download App</p>
			<p class="text-lg-center text-sm-left">
				<img
					src="../../assets/img/google-play.png"
					alt=""
					class="cursor-pointer"
					@click="gotoAppStore('google')"
				/>
				<img
					src="../../assets/img/app-store.png"
					class="ml-2 cursor-pointer"
					alt=""
					@click="gotoAppStore('apple')"
				/>
			</p>
		</section>
		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-lg-center text-sm-left">
				<a href="#nogo">Home</a>
				<a href="#nogo">Privacy Policy</a>
				<a href="#nogo">Terms of Use</a>
				<a href="#nogo">FAQ</a>
			</div>
			<div class="footer-copyright text-lg-center text-sm-left py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	name: "StripeCheckout",
	components: {},
	beforeCreate() {
		this.packages = this.$store.state.packages;
		this.$store.dispatch("account").then((res) => {
			if (res) {
				this.data = res.response;
				this.$store.commit("setLoader", false);
			}
		});
	},
	created() {
		var pid = this.$route.params.pid;
		var sid = this.$route.params.sid;
		this.$store.commit("showPopup", false);
		this.$store.commit("setLoader", true);
		const packages = this.$store.getters.getPackages;
		this.slugName = this.getSlugName(packages);
		if (this.$store.getters.getGlobalConfigs.provider_slug) {
			this.provider_slug = this.$store.getters.getGlobalConfigs.provider_slug;
		}
		if (
			this.$store.getters.getGlobalConfigs.country_name == "Nigeria" &&
			this.$route.query.recurringType == "recurring"
		) {
			this.type = "";
		} else {
			this.type = "one-time";
		}
		this.currentPackage = this.getSubsById(pid);
		if (this.$store.getters.getGlobalConfigs.country_name == "United States") {
			var Data = {
				slug: "stripe",
				payment_method_types: ["card"],
			};
		} else {
			var Data = {
				slug: "stripe",
			};
		}

		this.$store.dispatch("getClientStripeToken", Data);
		
	},
	mounted(){
		// grecaptcha.render('google_captcha', {
        //   'sitekey' : '6Ld2kLUpAAAAALUWcCInfaL3oAp5eOHA7fF7-me5',
        //   'callback' : this.captchaCallback
        // });
	},
	methods: {
		captchaCallback(response){
			// secret key to send to serve for verification
			//console.log('captcha response',response);
		},
		getSlugName(packages) {
			var slugName = "";
			for (let i = 0; i < packages.length; i++) {
				for (let j = 0; j < packages[i].subscriptions.length; j++) {
					if (packages[i].subscriptions[j].id == this.$route.params.sid) {
						slugName = packages[i].subscriptions[j].slug_name;
						break;
					}
				}
			}
			return slugName;
		},
		getCurrentsubs() {
			let cp = this.packages.find((ele) => ele.id == this.$route.params.pid);
			return cp.subscriptions.find((ele) => ele.id == this.$route.params.sid);
		},
		getPaymentHref() {
			return (
				"/#/selectpayment-dsp/" +
				this.$route.params.sid +
				"/" +
				this.$route.params.pid
			);
		},
		
		gotoSingin() {
			this.$router.push("/login");
		},
		getSubsById(pid) {
			var currentPackageObj = this.packages.find((ele) => ele.id == pid);
			return currentPackageObj;
		},
		processStripePayment() {
			this.$store.commit("setLoader", true);
			if (this.coupon.length > 0) {
				var dataToSend = {
					id: this.$route.params.sid,
					coupon: this.coupon
				};
			}
			else{
				var dataToSend = {
					id: this.$route.params.sid,
				};
			}

			this.$store
				.dispatch("stripeCheckout", dataToSend)
				.then((response) => {
					this.$store.commit("setLoader", false);
					const url = response.data.url;
					window.open(url, "_self");
				})
				.catch((err) => {
					this.showCouponError = true;
					this.couponErrorMsg = err.response.data.error.raw.message;
					this.$store.commit("setLoader", false);
					this.$store.commit(
						"setNotification",
						"Something went wrong please try again later"
					);
				});
		},
		getPlanDetails() {
			const sub = this.getCurrentsubs();
			if (sub.metaData.plan_details_keys) {
				const planDetails = JSON.parse(sub.metaData.plan_details_keys);
				return planDetails;
			} else {
				return "";
			}
		},
		isNotAvailabele(planDetails) {
			const sub = this.getCurrentsubs();
			if (sub.metaData[planDetails] == "false") {
				return true;
			}
			return false;
		},
		showPlanDeatils(planDetails) {
			const sub = this.getCurrentsubs();
			if (sub.metaData[planDetails]) {
				return true;
			}
			return false;
		},
	},
	computed: {
		subscription() {
			const subscriptions = this.data.subscriptions;
			let subscriptionString = subscriptions[0].package;

			return subscriptionString;
		},
		email() {
			if (this.data.profile) {
				return this.data.profile.username;
			}
		},
		subs() {
			if (this.data) {
				if (this.data.subscriptions.length >= 0) {
					return this.data.subscriptions[0];
				} else {
					return [];
				}
			}
		},

		planCurrency() {
			const sub = this.getCurrentsubs();
			if (sub.currency) {
				return sub.currency;
			} else {
				return "";
			}
		},
		planPrice() {
			const sub = this.getCurrentsubs();
			if (sub.price) {
				return sub.price;
			} else {
				return "";
			}
		},

		planSub() {
			const subs = this.getCurrentsubs();
			if (subs.title) {
				return subs.title;
			} else {
				return "";
			}
		},
	},

	data() {
		return {
			slugName: "",
			provider_slug: "",
			type: "",
			data: null,
			checked: false,
			currentSubs: null,
			currentPackage: null,
			client_token: "",
			coupon: "",
			showCouponError: false,
			couponErrorMsg: "",
		};
	},
};
</script>
<style scoped>
.coupon-input {
	width: 200px;
}
.form-control {
	border: 1px solid #ced4da !important;
}
.gray-text {
	color: gray;
}
.coupon-wrapper {
	max-width: 500px;
}
.coupon-error-text{
	font-size: 16px;
	font-weight: 400;
}
</style>
